/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The necessary data to register a new company [ deprecated as of 3.2.0 ]
 */
export type CompanyRegistration = {
  email: string
  company_name: string
  first_name: string
  last_name: string
  telephone?: string | null
  /**
   * label of the chosen clockin tier
   */
  tier: CompanyRegistration.tier
  app_check_token: string
}
export namespace CompanyRegistration {
  /**
   * label of the chosen clockin tier
   */
  export enum tier {
    ATTENDANCE = 'attendance',
    DOCUMENTATION = 'documentation',
  }
}
